import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDataset from './datasets.reducer';

export const selectDatasetsState = createFeatureSelector<fromDataset.DatasetBrowser>(fromDataset.datasetsFeatureKey);
export const selectDatasetsPersistState = createFeatureSelector<fromDataset.PersistDatasetBrowser>(
  fromDataset.datasetsFeatureKey
);

export const selectDatasetsPagination = createSelector(selectDatasetsState, (state) => state.pagination);
export const selectDatasetBrowserData = createSelector(selectDatasetsState, (state) => state.datasetBrowserData);

// Select workspace dataset data
export const selectWorkspaceDatasetBrowserData = createSelector(
  selectDatasetsPersistState,
  (state) => state.workspace.datasetBrowserData
);

// Select personal dataset data
export const selectPersonalDatasetBrowserData = createSelector(
  selectDatasetsPersistState,
  (state) => state.personal.datasetBrowserData
);

// Select workspace pagination
export const selectWorkspacePagination = createSelector(
  selectDatasetsPersistState,
  (state) => state.workspace.pagination
);

// Select personal pagination
export const selectPersonalPagination = createSelector(
  selectDatasetsPersistState,
  (state) => state.personal.pagination
);

export const selectWorkspaceSearchTerm = createSelector(
  selectDatasetsPersistState,
  (state) => state.workspace.searchTerm
);

export const selectPersonalSearchTerm = createSelector(
  selectDatasetsPersistState,
  (state) => state.personal.searchTerm
);
